import { HOST_PATHNAME } from "./partnerConstants";

export const formReferralLink = ({refshare, campaign, channel}) => {
    const urlSearchParams = new URLSearchParams();
    if (refshare) urlSearchParams.set('a', refshare);
    if (campaign) urlSearchParams.set('ac', campaign);
    if (channel) urlSearchParams.set('ch', channel);
    return `${HOST_PATHNAME}?${urlSearchParams.toString()}`;
};
